module.exports = __webpack_public_path__ + "static/media/YF71_2.d770af0a.jpg";